package com.evoapps.evoshift.domain.usecase.marketplace

import com.evoapps.evoshift.domain.model.SwapStatus
import com.evoapps.evoshift.domain.repository.ShiftRepository

/**
 * The initiator withdraws their own swap request ("Wycofaj prośbę", SH-165) while it still waits:
 * for the manager or the colleague (REQUESTED_BY_OWNER), on the marketplace (AVAILABLE) or with a
 * colleague's claim waiting for approval (TAKEN_PENDING). The shift stays theirs. A rejected
 * request is dismissed the same way. Only the initiator (firestore.rules agree).
 */
class CancelSwapRequestUseCase(
    private val shiftRepository: ShiftRepository
) {
    suspend operator fun invoke(shiftId: String, requestingUserId: String): Result<Unit> = runCatching {
        val shift = shiftRepository.getShift(shiftId).getOrThrow()
        val request = shift.swapRequest ?: throw IllegalStateException("No active request")
        if (request.initiatorUserId != requestingUserId || shift.userId != requestingUserId) {
            throw IllegalStateException("Only the person who asked can withdraw the request")
        }
        shiftRepository.updateSwapRequest(shiftId, null).getOrThrow()
    }

    companion object {
        /** SH-165: the states in which "Withdraw request" is offered. */
        val WITHDRAWABLE = setOf(SwapStatus.REQUESTED_BY_OWNER, SwapStatus.AVAILABLE, SwapStatus.TAKEN_PENDING)
    }
}
